import { createFileRoute } from '@tanstack/react-router';
import { DocPage } from '@/components/docs/DocPage';
import { jogosDocTitle, jogosDocDescription, jogosDocSections } from '@/content/docs/jogos';

export const Route = createFileRoute('/_admin/docs/jogos')({
  component: DocsJogosPage,
});

function DocsJogosPage() {
  return (
    <DocPage
      title={jogosDocTitle}
      description={jogosDocDescription}
      sections={jogosDocSections}
    />
  );
}
